const desktopNav = ($el) => {
    if (typeof $el !== 'undefined' && $el != null) {
        const $desktopDropdownToggles = [...$el.querySelectorAll('.js-desktop-nav-dropdown-toggle')]
        const $desktopDropdownMenus = [...$el.querySelectorAll('.js-desktop-nav-dropdown-menu')]
        const activeDropdownClass = 'is-active'

        if ($desktopDropdownToggles) {
            $desktopDropdownToggles.forEach((link) => {
                link.addEventListener('click', (e) => {
                    e.preventDefault()
                    const target = e.target.parentNode
                    const ele = target.nextElementSibling

                    $desktopDropdownMenus.forEach((element) => {
                        if (element !== ele) {
                            element.previousElementSibling.classList.remove(activeDropdownClass)
                            element.classList.remove(activeDropdownClass)
                        }
                    })
                    target.classList.toggle(activeDropdownClass)
                    ele.classList.toggle(activeDropdownClass)
                })
            })

            /**
             * Close the menu if click is outside dropdown
             */
            const closeMenuClickOuside = (e, $desktopDropdownMenus) => {
                $desktopDropdownMenus.forEach((element) => {
                    if (!element.parentNode.contains(e.target) && element.classList.contains(activeDropdownClass)) {
                        element.previousElementSibling.classList.remove(activeDropdownClass)
                        element.classList.remove(activeDropdownClass)
                    } 
                })
            }

            document.addEventListener('click', (e) => {
                closeMenuClickOuside(e, $desktopDropdownMenus)
            })
        }
    }
}

export default desktopNav